import { c as _c } from "react/compiler-runtime";
import { faClone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from '@xefi/x-react/form';
import { Modal } from '@xefi/x-react/modal';
import { Tooltip } from '@xefi/x-react/tooltip';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToasts } from '@/hooks/useToasts';
import type { SurveyHome } from '@/models/survey';
import { useDuplicateSurveyMutation } from '../../_hooks/useDuplicateSurveyMutation';
type DuplicateSurveyProps = {
  survey: SurveyHome;
};
export const DuplicateSurvey = t0 => {
  const $ = _c(43);
  const {
    survey
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    addSuccessToast,
    addErrorToast
  } = useToasts();
  const duplicateSurveyMutation = useDuplicateSurveyMutation();
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);
  const duplicateRef = useRef(null);
  let t1;
  if ($[0] !== t) {
    t1 = t("survey.duplication.action").toUpperCase();
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("duplicate", {
      ns: "common"
    });
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("cancel", {
      ns: "common"
    });
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== duplicateSurveyMutation.isPending) {
    t4 = {
      isLoading: duplicateSurveyMutation.isPending
    };
    $[6] = duplicateSurveyMutation.isPending;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== addErrorToast || $[9] !== addSuccessToast || $[10] !== duplicateSurveyMutation || $[11] !== survey.id || $[12] !== survey.title || $[13] !== t) {
    t5 = () => {
      duplicateSurveyMutation.mutate({
        surveyId: survey.id,
        title: duplicateRef?.current?.value || `${survey.title}_${t("copy", {
          ns: "common"
        })}`
      }, {
        onSuccess: () => {
          addSuccessToast(t("survey.duplicated.success", {
            ns: "notifications"
          }));
        },
        onError: () => {
          addErrorToast(t("survey.duplicated.error", {
            ns: "notifications"
          }));
        }
      });
    };
    $[8] = addErrorToast;
    $[9] = addSuccessToast;
    $[10] = duplicateSurveyMutation;
    $[11] = survey.id;
    $[12] = survey.title;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isDuplicateModalOpen || $[16] !== t) {
    t6 = isDuplicateModalOpen ? "" : t("duplicate", {
      ns: "common"
    });
    $[15] = isDuplicateModalOpen;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <button className="flex size-8 cursor-pointer items-center justify-center rounded-md transition-colors"><FontAwesomeIcon size="lg" icon={faClone} /></button>;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6) {
    t8 = <Tooltip content={t6} placement="top" size="sm" trigger={t7} />;
    $[19] = t6;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = `${t("survey.duplication.modal")} "${survey.title}"`;
  let t10;
  if ($[21] !== t9) {
    t10 = <p className="text-sm">{t9}</p>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("rename", {
      ns: "common"
    });
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <h4 className="mb-2 text-sm font-semibold">{t11}</h4>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = `${survey.title}_${t("copy", {
    ns: "common"
  })}`;
  let t14;
  if ($[27] !== t13) {
    t14 = <Input radius="md" type="text" name="title" defaultValue={t13} ref={duplicateRef} className="w-full" />;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="w-full">{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t15) {
    t16 = <div className="flex flex-col items-center gap-4">{t10}{t15}</div>;
    $[32] = t10;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t1 || $[36] !== t16 || $[37] !== t2 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t8) {
    t17 = <Modal title={t1} buttonActionLabel={t2} buttonCloseLabel={t3} onOpenChange={setIsDuplicateModalOpen} buttonActionProps={t4} onAction={t5} trigger={t8}>{t16}</Modal>;
    $[35] = t1;
    $[36] = t16;
    $[37] = t2;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t8;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  return t17;
};